import React, { useState, useEffect } from "react";

import { API, graphqlOperation } from "aws-amplify";
import {
  createZone,
  updateZone,
  deleteZone,
  deleteLocation,
  deleteAisle,
  updateAisle,
  updateLocation,
} from "../../../../graphql/mutations";
import { updateInventoryItemMini } from "../../../../graphql/inventory/custom-mutations";
import { accountByActiveByNameDropDown } from "../../../../graphql/account/account-queries";
import { inventoryItemByZoneByStatusMini } from "../../../../graphql/inventory/custom-queries";
import {
  aisleByActiveByZoneBySortKey,
  inventoryItemByZoneByStatus,
  locationByAisleBySortKey,
  locationByZoneBySortKey,
} from "../../../../graphql/queries";
import { sanitizeInventoryItem } from "../../../../graphql/inventory/inventoryCRUD";

import { useNotify } from "react-admin";

import {
  Backdrop,
  Badge,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { AddIcon } from "../../../../components/common/iconography";
import { CirclePicker } from "react-color";
import { logError } from "../../../../utils/appUtils";
import {
  AreaType,
  colorsDark,
  InventoryStatus,
  LocationLoadType,
  Unit,
} from "../../../../utils/constants";
import {
  getArea,
  getLocationFullName,
  hasTrackCarsOnLocations,
} from "../../../../utils/locationUtils";
import { getSquaredAreaUOM } from "../../../../utils/loadTypeUtils";
const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: theme.spacing(0),
    marginRight: theme.spacing(0),
    marginBottom: theme.spacing(4),
  },
  addContainer: {
    display: "flex",
    justifyContent: "center",
  },
  location: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    border: "1px dashed",
    borderRadius: theme.spacing(1),
    borderColor: grey[400],
    padding: theme.spacing(2),
    minHeight: theme.spacing(8),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  locationTitle: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(4),
  },
  item: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: theme.spacing(0.5),
  },
  avatar: {
    "&:hover": {
      cursor: "grab",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
}));

const Zones = ({ record, areas, aisles, getData }) => {
  const classes = useStyles();
  const notify = useNotify();
  const [allAccounts, setAllAccounts] = useState([]);
  const [accountLotPrefixMap, setAccountLotPrefixMap] = useState({});
  const [openDelete, setOpenDelete] = useState(false);
  const [openRename, setOpenRename] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [selectedZone, setSelectedZone] = useState();
  const [loading, setLoading] = useState();

  useEffect(() => {
    getAccounts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAccounts = async () => {
    try {
      const response = await API.graphql(
        graphqlOperation(accountByActiveByNameDropDown, {
          reloadYardId: record.id,
          activeBusinessName: { beginsWith: { active: "true" } },
        }),
      );

      const accounts = response.data.accountByActiveByName.items;
      accounts.forEach(
        (itm) => (accountLotPrefixMap[itm.id] = itm.lotNumberPrefix),
      );
      setAccountLotPrefixMap(accountLotPrefixMap);
      setAllAccounts(accounts);
    } catch (err) {
      logError("resources:reloadYard:Zones:getAccounts", err, notify);
    }
  };

  const openRenameDialog = (zone) => {
    setSelectedZone(zone);
    setOpenRename(true);
  };

  const addZone = async (newZone) => {
    debugger;
    try {
      setLoading(true);
      let areaZones = newZone.area.zones.items;
      const input = { ...newZone };
      input.active = "true";
      input.groups = record.groups;
      input.reloadYardId = record.id;
      input.prefix = newZone.prefix?.trim().toUpperCase() || "";
      input.sortKey = areaZones?.length
        ? areaZones[areaZones.length - 1].sortKey + 1
        : 1;
      input.color = newZone.color ? newZone.color : "#90A4AE";
      delete input.area;

      await API.graphql(graphqlOperation(createZone, { input }));
      getData();
      setSelectedZone(null);
      setAddOpen(false);
    } catch (error) {
      logError("resources:reloadYard:Zones:addZone", error, notify);
    } finally {
      setLoading(false);
    }
  };

  const processInventoriesUpdate = async (selectedZone) => {
    const responseList = [];
    debugger;

    const statusQueries = [
      InventoryStatus.UNLOADED,
      InventoryStatus.REVIEW,
      InventoryStatus.STORED,
    ];

    for (const queryStatus of statusQueries) {
      let nextToken = true;
      const searchQuery = {
        zoneId: selectedZone.id,
        status: { beginsWith: queryStatus },
        limit: 1000,
      };

      while (nextToken) {
        const input =
          nextToken === true ? searchQuery : { nextToken, ...searchQuery };
        let results = await API.graphql(
          graphqlOperation(inventoryItemByZoneByStatus, input),
        );
        const inventoryItems =
          results.data.inventoryItemByZoneByStatus.items.filter(
            (item) => item.locationId,
          );
        nextToken = results.data.inventoryItemByZoneByStatus.nextToken;

        const responses = await Promise.allSettled(
          inventoryItems.map((inventoryItem) => {
            return doUpdateInventoryItem(inventoryItem, selectedZone);
          }),
        );
        responseList.push(...responses);
      }
    }

    const resError = responseList.find((item) => item.status === "rejected");
    if (resError) {
      logError(
        "reloadYard:Zones::processInventoriesUpdate:response",
        resError,
        false,
      );
      throw resError;
    }
  };

  const doUpdateInventoryItem = (inventoryItem, selectedZone) => {
    const inventoryLocation = {
      ...inventoryItem.location,
      area: inventoryItem.area,
      zone: selectedZone,
      aisle: aisles.find((itm) => itm.zoneId === selectedZone.id),
    };

    let toUpdateInventoryItem = {
      ...inventoryItem,
      locationFullName: getLocationFullName(inventoryLocation),
      zoneId: selectedZone.id,
    };

    toUpdateInventoryItem = sanitizeInventoryItem(toUpdateInventoryItem);

    debugger;
    return API.graphql(
      graphqlOperation(updateInventoryItemMini, {
        input: toUpdateInventoryItem,
      }),
    );
  };

  const renameZone = async (zone) => {
    debugger;
    if (!zone) return;

    try {
      setLoading(true);
      zone.prefix = zone.prefix?.trim().toUpperCase() || "";
      await doUpdateZone(zone);
      await processInventoriesUpdate(zone);
      setSelectedZone(null);
      setOpenRename(false);
      getData();
      notify("Zone updated succesfully.", "info");
    } catch (error) {
      logError("reloadYard:Zones:renameZone", error, notify);
    } finally {
      setLoading(false);
    }
  };

  const doUpdateZone = async (zone) => {
    const toUpdateZone = { ...zone };
    delete toUpdateZone.createdAt;
    delete toUpdateZone.updatedAt;
    delete toUpdateZone.area;
    delete toUpdateZone.aisles;

    await API.graphql(graphqlOperation(updateZone, { input: toUpdateZone }));
  };

  const doDeleteZone = async (zone) => {
    const input = { id: zone.id };
    await API.graphql(graphqlOperation(deleteZone, { input }));
  };

  const doUpdateZones = async (zones) => {
    debugger;
    const results = await Promise.allSettled(
      zones.map((itm) => {
        const toUpdateZone = { ...itm };
        delete toUpdateZone.createdAt;
        delete toUpdateZone.updatedAt;
        delete toUpdateZone.aisles;
        return API.graphql(
          graphqlOperation(updateZone, { input: toUpdateZone }),
        );
      }),
    );

    const resError = results.find((itm) => itm.status === "rejected");
    debugger;
    if (resError) {
      logError("reloadYard:Zones:doUpdateZones", resError, false);
      throw resError;
    }
  };

  const doDeleteAisles = async (zoneId) => {
    const locationResponse = await API.graphql(
      graphqlOperation(aisleByActiveByZoneBySortKey, {
        zoneId: zoneId,
        activeSortKey: { beginsWith: { active: "true" } },
        limit: 1000,
      }),
    );
    let toDeleteAisles =
      locationResponse.data.aisleByActiveByZoneBySortKey.items;
    const promiseList = toDeleteAisles.map((aisle) => {
      debugger;
      return API.graphql(
        graphqlOperation(deleteAisle, { input: { id: aisle.id } }),
      );
    });

    const results = await Promise.allSettled(promiseList);
    const resError = results.find((itm) => itm.status === "rejected");

    if (resError) {
      logError("reloadYard:Area:doDeleteLocations", resError, false);
      throw resError;
    }
  };

  const doDeleteLocations = async (zoneId) => {
    const locationRsponse = await API.graphql(
      graphqlOperation(locationByZoneBySortKey, {
        reloadYardId: record.id,
        zoneIdSortKey: { beginsWith: { zoneId } },
      }),
    );
    let locations = locationRsponse.data.locationByZoneBySortKey.items;
    const promiseList = locations.map((location) => {
      return API.graphql(
        graphqlOperation(deleteLocation, { input: { id: location.id } }),
      );
    });
    const results = await Promise.allSettled(promiseList);
    const resError = results.find((itm) => itm.status === "rejected");
    if (resError) {
      logError("reloadYard:Zones:doDeleteLocations", resError, false);
      throw resError;
    }
  };

  const doUpdateAisles = async (toUpdateAisles) => {
    const results = await Promise.allSettled(
      toUpdateAisles.map((itm) => {
        const toUpdateAisle = { ...itm };
        delete toUpdateAisle.area;
        delete toUpdateAisle.createdAt;
        delete toUpdateAisle.locations;
        delete toUpdateAisle.updatedAt;
        delete toUpdateAisle.zone;
        return API.graphql(
          graphqlOperation(updateAisle, { input: toUpdateAisle }),
        );
      }),
    );

    const resError = results.find((itm) => itm.status === "rejected");

    if (resError) {
      logError("reloadYard:Zones:doUpdateAisles", resError, false);
      throw resError;
    }
  };

  const doUpdateLocations = async (toUpdateLocations) => {
    debugger;
    const results = await Promise.allSettled(
      toUpdateLocations.map((itm) => {
        const toUpdateLocation = {
          ...itm,
          productId: itm.productId ? itm.productId : "",
        };
        delete toUpdateLocation.aisle;
        delete toUpdateLocation.area;
        delete toUpdateLocation.createdAt;
        delete toUpdateLocation.tags;
        delete toUpdateLocation.updatedAt;
        delete toUpdateLocation.zone;

        return API.graphql(
          graphqlOperation(updateLocation, { input: toUpdateLocation }),
        );
      }),
    );

    const resError = results.find((itm) => itm.status === "rejected");

    if (resError) {
      logError("reloadYard:Zones:doUpdateLocations", resError, false);
      throw resError;
    }
  };

  const disableDelete = (zone) => {
    debugger;
    const selectedArea = areas.find((itm) => itm.id === zone.areaId);
    const areaZones = selectedArea.zones.items;
    return areaZones?.length === 1;
  };

  const openDeleteDialog = (zone) => {
    setSelectedZone(zone);
    setOpenDelete(true);
  };

  const handleDeleteZone = (zone) => {
    if (disableDelete(zone)) {
      notify("Must have at least 1 Zone per Area.", "warning");
    } else {
      let zoneLocations = aisles.some((itm) => itm.zoneId === zone.id);
      if (zoneLocations) openDeleteDialog(zone);
      else removeZonesLocations(zone);
    }
  };

  const collectZoneTrackLocationIds = (zone) => {
    if (!zone) return [];
    const zoneAisles = aisles.filter((aisle) => aisle.zoneId === zone.id);
    const trackIds = [];
    zoneAisles.forEach((aisle) => {
      (aisle.locations?.items || []).forEach((location) => {
        trackIds.push(location.id);
      });
    });
    return trackIds;
  };

  const removeZonesLocations = async (zone) => {
    if (!zone) return;

    let isOnTrack, isStored, isUnloaded, isReview, isShipped, isHeld;
    let results;
    debugger;

    let logLocation = "reloadYard:Zones:removeZonesLocations:countInventories";
    try {
      setLoading(true);
      setOpenDelete(false);

      const area = areas.find((itm) => itm.id === zone.areaId);

      if (area.areaType === AreaType.TRACK) {
        const trackIds = collectZoneTrackLocationIds(zone);
        isOnTrack = await hasTrackCarsOnLocations(trackIds);
      } else {
        debugger;
        const searchQuery = {
          zoneId: zone.id,
          status: { beginsWith: InventoryStatus.STORED },
          limit: 1,
        };

        results = await API.graphql(
          graphqlOperation(inventoryItemByZoneByStatusMini, searchQuery),
        );
        isStored = results.data.inventoryItemByZoneByStatus.items.length > 0;

        if (!isStored) {
          searchQuery.status.beginsWith = InventoryStatus.UNLOADED;
          results = await API.graphql(
            graphqlOperation(inventoryItemByZoneByStatusMini, searchQuery),
          );
          isUnloaded =
            results.data.inventoryItemByZoneByStatus.items.length > 0;
        }

        if (!isStored && !isUnloaded) {
          searchQuery.status.beginsWith = InventoryStatus.REVIEW;
          results = await API.graphql(
            graphqlOperation(inventoryItemByZoneByStatusMini, searchQuery),
          );
          isReview = results.data.inventoryItemByZoneByStatus.items.length > 0;
        }

        isHeld = isStored || isUnloaded || isReview;
        if (!isHeld) {
          searchQuery.status.beginsWith = InventoryStatus.SHIPPED;
          results = await API.graphql(
            graphqlOperation(inventoryItemByZoneByStatusMini, searchQuery),
          );
          isShipped = results.data.inventoryItemByZoneByStatus.items.length > 0;
        }
      }

      debugger;
      logLocation = "reloadYard:YardLayout:handleDelete:deleteZone";
      if (isHeld) {
        notify("Zone has Locations that are in use!", "warning");
        return Promise.resolve();
      } else if (isOnTrack) {
        notify("Zone has Tracks with placed railcars!", "warning");
        return Promise.resolve();
      } else if (isShipped) {
        debugger;
        logLocation = "reloadYard:Zones:removeZonesLocations:updateZone";
        zone.active = "false";
        await doUpdateZone(zone);

        const toUpdateAisles = aisles.filter(
          (aisle) => aisle.zoneId === zone.id,
        );
        toUpdateAisles.forEach((itm) => (itm.active = "false"));
        await doUpdateAisles(toUpdateAisles);

        const toUpdateLocations = [];
        for (const aisle of toUpdateAisles) {
          if (aisle.locations.nextToken) {
            const response = await API.graphql(
              graphqlOperation(locationByAisleBySortKey, {
                aisleId: aisle.id,
                limit: 1000,
              }),
            );
            const activeLocations =
              response.data.locationByAisleBySortKey.items.filter(
                (itm) => itm.active === "true",
              );
            toUpdateLocations.push(...activeLocations);
          } else {
            toUpdateLocations.push(...aisle.locations.items);
          }
        }
        toUpdateLocations.forEach((location) => (location.active = "false"));
        await doUpdateLocations(toUpdateLocations);

        const currentArea = areas.find((area) => (area.id = zone.areaId));
        currentArea.zones.items = currentArea.zones.items.filter(
          (itm) => itm.id !== zone.id,
        );
        currentArea.zones.items.forEach((itm, idx) => (itm.sortKey = idx));
        await doUpdateZones(currentArea.zones.items);
        notify("Zone deleted succesfully.", "info");
      } else {
        debugger;
        logLocation = "reloadYard:Zones:removeZonesLocations:deleteZone";
        await doDeleteLocations(zone.id);
        await doDeleteAisles(zone.id);
        await doDeleteZone(zone);

        const currentArea = areas.find((area) => (area.id = zone.areaId));
        currentArea.zones.items = currentArea.zones.items.filter(
          (itm) => itm.id !== zone.id,
        );
        currentArea.zones.items.forEach((itm, idx) => (itm.sortKey = idx));
        await doUpdateZones(currentArea.zones.items);
        notify("Zone deleted succesfully.", "info");
      }

      getData();
    } catch (error) {
      logError(logLocation, error, notify);
    } finally {
      setLoading(false);
      setSelectedZone(null);
      setOpenDelete(false);
    }
  };

  const allowDrop = (evt) => {
    evt.preventDefault();
  };

  const drag = (evt, zone) => {
    evt.dataTransfer.setData("data", zone.id);
  };

  const drop = async (evt, toZone) => {
    try {
      setLoading(true);
      const selectedArea = areas.find((itm) => itm.id === toZone.areaId);
      const toIdx = selectedArea.zones.items.findIndex(
        (itm) => itm.id === toZone.id,
      );
      const fromZoneId = evt.dataTransfer.getData("data");
      const fromIdx = selectedArea.zones.items.findIndex(
        (itm) => itm.id === fromZoneId,
      );
      const fromZone = selectedArea.zones.items[fromIdx];
      if (fromZone.areaId !== toZone.areaId) return;
      evt.preventDefault();

      selectedArea.zones.items.splice(fromIdx, 1);
      selectedArea.zones.items.splice(toIdx, 0, fromZone);
      selectedArea.zones.items.forEach((itm, idx) => (itm.sortKey = idx));

      await doUpdateZones(selectedArea.zones.items);
      notify("Zone updated succesfully.", "info");
      getData();
    } catch (err) {
      logError("reloadYard:Zones:drop", err, notify);
    } finally {
      setLoading(false);
    }
  };

  const getLotNumberPrefix = (zone) => {
    const prefix = accountLotPrefixMap[zone.accountId];
    return prefix.slice(0, -1);
  };

  return (
    <>
      {!openRename && !addOpen && (
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <form className={classes.container} onSubmit={addZone}>
        <div className={classes.addContainer}>
          <Button
            onClick={() => setAddOpen(true)}
            color="primary"
            variant="outlined"
            startIcon={<AddIcon />}
          >
            Add Zone
          </Button>
        </div>
        {areas.map((area) => (
          <div key={area.name}>
            <Typography variant="subtitle2" className={classes.locationTitle}>
              {area.name}
            </Typography>
            <div className={classes.location}>
              {area.zones.items.length === 0 ? (
                <Typography color="textSecondary">Add zones</Typography>
              ) : (
                area.zones.items.map((zone, idx) => {
                  return (
                    <div key={zone.id} className={classes.item}>
                      {accountLotPrefixMap[zone.accountId] ? (
                        <Badge
                          color="secondary"
                          badgeContent={getLotNumberPrefix(zone)}
                        >
                          <Chip
                            label={zone.name}
                            draggable="true"
                            onDragStart={(evt) => drag(evt, zone)}
                            onDragOver={(evt) => allowDrop(evt)}
                            onDrop={(evt) => drop(evt, zone)}
                            clickable
                            onClick={() => openRenameDialog(zone)}
                            onDelete={() => handleDeleteZone(zone)}
                            className={classes.avatar}
                            style={{
                              fontWeight: "bold",
                              color: "#ffffff",
                              backgroundColor: zone.color
                                ? zone.color
                                : "#90A4AE",
                            }}
                          />
                        </Badge>
                      ) : (
                        <Chip
                          label={zone.name}
                          draggable="true"
                          onDragStart={(evt) => drag(evt, zone)}
                          onDragOver={(evt) => allowDrop(evt)}
                          onDrop={(evt) => drop(evt, zone)}
                          clickable
                          onClick={() => openRenameDialog(zone)}
                          onDelete={() => handleDeleteZone(zone)}
                          className={classes.avatar}
                          style={{
                            fontWeight: "bold",
                            color: "#ffffff",
                            backgroundColor: zone.color
                              ? zone.color
                              : "#90A4AE",
                          }}
                        />
                      )}
                    </div>
                  );
                })
              )}
            </div>
          </div>
        ))}
      </form>
      <Dialog open={openDelete}>
        <DialogTitle id="delete-zone">Delete Zone</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Warning, deleting a Zone will delete all Locations within that zone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => setOpenDelete(false)}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            onClick={() => removeZonesLocations(selectedZone)}
            color="primary"
            autoFocus
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      {openRename && (
        <ZoneDialog
          title="Rename Zone"
          areas={areas}
          zone={selectedZone}
          allAccounts={allAccounts}
          open={openRename}
          handleCancel={() => setOpenRename(false)}
          handleClose={renameZone}
          loading={loading}
          classes={classes}
        />
      )}
      {addOpen && (
        <ZoneDialog
          title="Create Zone"
          areas={areas}
          zone={{}}
          allAccounts={allAccounts}
          open={addOpen}
          handleCancel={() => setAddOpen(false)}
          handleClose={addZone}
          loading={loading}
          classes={classes}
        />
      )}
    </>
  );
};

export const ZoneDialog = ({
  title,
  zone,
  areas,
  allAccounts,
  open,
  handleCancel,
  handleClose,
  loading,
}) => {
  const classes = useStyles();
  const [selectedZone, setSelectedZone] = useState(
    zone?.id ? zone : { areaId: areas[0].id },
  );
  const [inputValue, setInputValue] = useState("");
  const [defaultAccountValue, setDefaultAccoutValue] = useState();
  const [error, setError] = useState({});
  const areaUnitOptions = getSquaredAreaUOM();

  useEffect(() => {
    debugger;
    if (zone) {
      const zoneArea = zone.areaId
        ? areas.find((area) => area.id === zone.areaId)
        : undefined;
      setSelectedZone(
        zone?.id ? { ...zone, area: zoneArea } : { areaId: areas[0].id },
      );
      if (zone.accountId) {
        const account = allAccounts.find((itm) => itm.id === zone.accountId);
        if (account) {
          setDefaultAccoutValue(account);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zone]);

  const setAccountInputValue = (event, newInputValue) => {
    debugger;
    setInputValue(newInputValue);
  };

  const setSelectedAccount = (evt, value, reason) => {
    debugger;
    if (reason === "select-option") {
      setDefaultAccoutValue(value);
      setSelectedZone({
        ...selectedZone,
        accountId: value.id,
        leasedAreaUOM: selectedZone?.leasedAreaUOM || Unit.SF,
      });
    } else {
      setDefaultAccoutValue(null);
      setSelectedZone({
        ...selectedZone,
        accountId: null,
        leasedArea: null,
        leasedAreaUOM: null,
      });
    }
  };

  const setSelectedColor = (color) => {
    setSelectedZone({ ...selectedZone, color: color.hex });
  };

  const setZoneName = (name) => {
    setSelectedZone({ ...selectedZone, name });
  };

  const setZonePrefix = (prefix) => {
    setSelectedZone({ ...selectedZone, prefix: prefix.trim().toUpperCase() });
  };

  const setZoneArea = (areaId) => {
    const area = areas.find((itm) => itm.id === areaId);
    if (showAccount(area)) {
      setSelectedZone({ ...selectedZone, areaId, area });
    } else {
      setDefaultAccoutValue(null);
      setSelectedZone({
        ...selectedZone,
        areaId,
        area,
        accountId: null,
        leasedArea: null,
        leasedAreaUOM: null,
      });
    }
  };

  const setZoneCommodity = (commodityId) => {
    setSelectedZone({ ...selectedZone, reloadYardCommodityId: commodityId });
  };

  const setZoneLeasedArea = (leasedArea) => {
    if (!/^\d*$/.test(leasedArea)) return;
    setSelectedZone({
      ...selectedZone,
      leasedArea: leasedArea === "" ? null : Number(leasedArea),
    });
  };

  const setZoneLeasedAreaUOM = (leasedAreaUOM) => {
    setSelectedZone({
      ...selectedZone,
      leasedAreaUOM,
    });
  };

  const validateForm = () => {
    debugger;
    let hasError = false;
    const error = {};

    if (!selectedZone.name) {
      error.name = "Zone name is required";
      hasError = true;
    }
    let duplicatePrefix = selectedZone.area.zones.items.find(
      (itm) =>
        itm.id !== selectedZone.id &&
        itm.name?.toUpperCase() === selectedZone.name?.toUpperCase() &&
        itm.areaId === selectedZone.areaId,
    );
    if (duplicatePrefix) {
      error.name = "Duplicate zone name";
      hasError = true;
    }
    // if (!selectedZone.prefix) {
    //     error.prefix = "Zone prefix is required";
    //     hasError = true;
    // } else
    if (selectedZone.prefix?.length > 2) {
      error.prefix = "Zone prefix max. length is 2 characters";
      hasError = true;
    } else {
      // check for duplicate zone prefix in the same area as selectedZone
      duplicatePrefix = selectedZone.area.zones.items.find(
        (itm) =>
          itm.id !== selectedZone.id &&
          itm.areaId === selectedZone.areaId &&
          (itm.prefix?.toUpperCase() === selectedZone.prefix?.toUpperCase() ||
            (!itm.prefix && !selectedZone.prefix)),
      );
      if (duplicatePrefix) {
        error.prefix = "Duplicate zone prefix";
        hasError = true;
      }
    }
    if (!selectedZone.areaId) {
      error.areaid = "Area is required";
      hasError = true;
    }
    if (
      selectedZone?.leasedArea != null &&
      (!Number.isInteger(selectedZone.leasedArea) ||
        selectedZone.leasedArea < 0)
    ) {
      error.leasedArea = "Must be a valid non-negative number";
      hasError = true;
    }
    if (
      selectedZone?.leasedArea != null &&
      selectedZone?.leasedArea !== "" &&
      !selectedZone?.leasedAreaUOM
    ) {
      error.leasedAreaUOM = "Required";
      hasError = true;
    }

    setError(error);
    return hasError;
  };

  const handleSubmit = (evt) => {
    if (evt.preventDefault) evt.preventDefault();
    debugger;
    if (!selectedZone.area) {
      debugger;
      const area = areas.find((itm) => itm.id === selectedZone.areaId);
      selectedZone.area = area;
      setSelectedZone({ ...selectedZone });
    }
    const hasError = validateForm();

    if (!hasError) {
      if (!selectedZone.area) {
        debugger;
        const area = areas.find((itm) => itm.id === selectedZone.areaId);
        setSelectedZone({ ...selectedZone, area });
      }
      handleClose(selectedZone);
    }
  };

  const getCommodities = () => {
    debugger;
    const bulkCommodities =
      window.appUser.reloadYard.activeYardCommodities.items.filter(
        (itm) =>
          itm.commodity.locationLoadType === LocationLoadType.DRY_BULK ||
          itm.commodity.locationLoadType === LocationLoadType.LIQUID_BULK,
      );
    return [{ id: "", commodity: { name: "" } }, ...bulkCommodities];
  };

  const showCommodityInput = () => {
    if (!selectedZone.areaId) return false;
    const zoneArea = getArea(selectedZone.areaId);
    if (zoneArea.areaType === AreaType.TRACK && getCommodities().length > 1) {
      return true;
    }
    return false;
  };

  const showAccount = (area) => {
    return (
      area?.areaType !== AreaType.BULK && area?.areaType !== AreaType.TRACK
    );
  };

  const isPrefixRequired = () => {
    // only one zone per area can have a blank prfix.
    return selectedZone.area?.zones.items.find(
      (itm) =>
        itm.id !== selectedZone.id &&
        itm.areaId === selectedZone.areaId &&
        !itm.prefix,
    );
  };

  const isLeasedAreaEntered =
    selectedZone?.leasedArea != null && selectedZone?.leasedArea !== "";

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        style: {
          maxHeight: "calc(100% - 24px)",
        },
      }}
    >
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent style={{ overflowY: "visible" }}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              id="name"
              label="Zone name"
              margin="dense"
              variant="outlined"
              fullWidth
              autoFocus
              required
              value={selectedZone ? selectedZone.name : ""}
              onChange={(evt) => setZoneName(evt.target.value)}
              error={error.name}
              helperText={error.name ? error.name : ""}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="prefix"
              label="Zone prefix"
              margin="dense"
              variant="outlined"
              fullWidth
              required={isPrefixRequired()}
              value={selectedZone ? selectedZone.prefix : ""}
              onChange={(evt) => setZonePrefix(evt.target.value)}
              error={error.prefix}
              helperText={error.prefix ? error.prefix : ""}
              inputProps={{
                maxLength: 2,
                style: { textTransform: "uppercase" },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="area"
              label="Area"
              margin="dense"
              variant="outlined"
              select
              fullWidth
              required
              disabled={selectedZone?.id}
              value={selectedZone ? selectedZone.areaId : ""}
              onChange={(evt) => setZoneArea(evt.target.value)}
              error={error.areaId}
              helperText={error.areaId ? error.areaId : ""}
            >
              {areas.map((itm) => (
                <MenuItem key={itm.id} value={itm.id}>
                  {itm.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          {showCommodityInput() && (
            <Grid item xs={12}>
              <TextField
                id="load-type"
                label="Load type"
                margin="dense"
                variant="outlined"
                select
                fullWidth
                required
                disabled={selectedZone?.id}
                value={selectedZone ? selectedZone.reloadYardCommodityId : ""}
                onChange={(evt) => setZoneCommodity(evt.target.value)}
                error={error.areaId}
                helperText={error.areaId ? error.areaId : ""}
              >
                {getCommodities().map((itm) => (
                  <MenuItem key={itm.id} value={itm.id}>
                    {itm.commodity.name ? itm.commodity.name : <>&nbsp;</>}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          )}
          {showAccount(selectedZone?.area) && (
            <>
              <Grid item xs={12} sm={7}>
                <Autocomplete
                  id="account"
                  options={allAccounts}
                  value={defaultAccountValue}
                  inputValue={inputValue}
                  onChange={setSelectedAccount}
                  onInputChange={setAccountInputValue}
                  fullWidth
                  getOptionLabel={(option) =>
                    option.displayName || option.businessName
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Tenant Account"
                      margin="dense"
                      size="small"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  type="number"
                  id="leasedArea"
                  label="Leased Area"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  required={Boolean(selectedZone?.leasedAreaUOM)}
                  disabled={!selectedZone?.accountId}
                  value={selectedZone?.leasedArea ?? ""}
                  onChange={(evt) => setZoneLeasedArea(evt.target.value)}
                  error={Boolean(error.leasedArea)}
                  helperText={error.leasedArea || ""}
                  inputProps={{
                    min: 0,
                    step: 1,
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <TextField
                  id="leasedAreaUOM"
                  label="UOM"
                  margin="dense"
                  variant="outlined"
                  select
                  fullWidth
                  required={isLeasedAreaEntered}
                  disabled={!selectedZone?.accountId}
                  value={selectedZone?.leasedAreaUOM ?? ""}
                  onChange={(evt) => setZoneLeasedAreaUOM(evt.target.value)}
                  error={Boolean(error.leasedAreaUOM)}
                  helperText={error.leasedAreaUOM || ""}
                >
                  {areaUnitOptions.map((unit) => (
                    <MenuItem key={unit.id} value={unit.id}>
                      {unit.name}
                    </MenuItem>
                  ))}
                </TextField>
                .{" "}
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <CirclePicker
              width="100%"
              onChangeComplete={setSelectedColor}
              color={selectedZone?.color ? selectedZone.color : ""}
              colors={colorsDark}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}> Cancel </Button>
        <Button type="submit" color="primary" onClick={handleSubmit}>
          {" "}
          Submit{" "}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Zones;
